<template>
  <b-modal size="lg"  v-model="visible" title="Informar Pago de Póliza">
    <b-row class="mb-3">
      <b-col>
        <p class="text-primary"><b>Seleccione póliza para la cual informar pago:</b></p>
      </b-col>
      <b-col>
        <b-select v-model="informe.poliza" :options="optPolizas" @blur="$v.informe.poliza.$touch" :state="$v.informe.poliza.$dirty ? !$v.informe.poliza.$error : null" />
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col>
        <p class="text-primary"><b>Seleccione fecha de pago:</b></p>
      </b-col>
      <b-col>
        <b-input type="date" v-model="informe.fecha_pago" @blur="$v.informe.fecha_pago.$touch" :state="$v.informe.fecha_pago.$dirty ? !$v.informe.fecha_pago.$error : null"/>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col>
        <p class="text-primary"><b>Indique importe abonado:</b></p>
      </b-col>
      <b-col>
        <b-input type="number" v-model="informe.importe" @blur="$v.informe.importe.$touch" :state="$v.informe.importe.$dirty ? !$v.informe.importe.$error : null"/>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col>
        <p class="text-primary"><b>Adjunte comprobante:</b></p>
      </b-col>
      <b-col>
        <b-form-file
          v-model="informe.adjunto"
          :state="Boolean(informe.adjunto)"
          placeholder="Adjuntar Archivo"
          drop-placeholder="Adjuntar Archivo"
        ></b-form-file>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <p class="text-primary"><b>Observaciones:</b></p>
        <b-textarea v-model="informe.observaciones"></b-textarea>
      </b-col>
    </b-row>
    <template v-slot:modal-footer>
      <div class="w-100">
        <b-button
          variant="primary"
          class="float-right"
          @click="submit"
        >
          Aceptar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { required, decimal, numeric } from 'vuelidate/lib/validators';
export default {
    props: {
        polizas: {
            type: Array
        },
        polizaSelected: {
            type: Object
        },
        tomador: {
            type: Object
        }
    },
    data () {
        return {
            visible: false,
            informe: {}
        }
    },
    validations: {
        informe: {
            poliza: { required, numeric },
            fecha_pago: { required },
            importe: { required, decimal },
            adjunto: { required }
        }
    },
    methods: {
        toggle() {
            this.visible = !this.visible
        },
        submit() {
            this.$v.informe.$touch();

            if (this.$v.informe.$invalid) {
                return null
            }

            const formData = new FormData();

            // datos del informe
            formData.append('nro_pol', this.informe.poliza);
            formData.append('fecha_pago', this.informe.fecha_pago);
            formData.append('importe', this.informe.importe);
            formData.append('adjunto', this.informe.adjunto); // archivo
            formData.append('observaciones', this.informe.observaciones);

            // datos del pas
            formData.append('pas_nombre', this.$store.state.auth.nombre);
            formData.append('pas_codigo', this.$store.state.auth.cod_agente);
            formData.append('pas_email', this.$store.state.auth.email);

            this.toggle();

            this.$api.post('tomador/informe-pago/' + this.$route.params.cod_tomador, formData, {
                headers: {
                    'Content-type': 'multipart/form-data'
                }
            }).then(() => {
                this.$toast.success('Informe de pago enviado exitosamente.');
            }).catch(err => {
                //console.log(err.response);
                this.$toast.error('Ocurrió un error al enviar el informe de pago');
            })
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.informe.poliza = this.polizaSelected.nro_pol;
                this.informe = {
                    poliza: '',
                    fecha_pago: '',
                    importe: '',
                    adjunto: ''
                }
                this.$v.$reset()
            }
        }
    },
    computed: {
        optPolizas() {
            return this.polizas.map(item => item.nro_pol);
        }
    }
}
</script>
